import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_item_post_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  author_guid: fromDatatype.GuidDataFieldInterface;
  author_name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  post_status: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.TextDatatypeInterface;
  post_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  content_option: fromDatatype.VarcharDatatypeInterface;
  content_body: fromDatatype.TextDatatypeInterface;
  publish_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  post_property_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_mst_item_post_hdr_RowClass implements bl_fi_mst_item_post_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  author_guid: fromDatatype.GuidDataFieldInterface;
  author_name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.TextDatatypeInterface;
  post_status: fromDatatype.VarcharDatatypeInterface;
  summary: fromDatatype.TextDatatypeInterface;
  post_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  content_option: fromDatatype.VarcharDatatypeInterface;
  content_body: fromDatatype.TextDatatypeInterface;
  publish_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  post_property_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
